import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../../hoc/Loading/Loading";
import axios from "../../../axios";
import {
  groupContentFields,
  groupPrivacyStatusDesc,
  groupRolePriviledge,
} from "../../../utils/constants";
import * as actionCreators from "../../../modules/actions/index";
import { connect } from "react-redux";
import * as url from "../../../utils/url";
import { whiteLabelStyling, isUserRemoved } from "../../../utils/constants";
import moment from "moment";
import { Modal, ModalBody, Button, ListGroupItem, Progress } from "reactstrap";
import LinkedChartItem from "../../weekly-wins/LinkedChartItem.jsx";
import noLinkedChart from "../../../assets/onboarding/analytics.png";
import loadingItems from "../../../assets/placeholders/kpi_available.svg";

class GroupAnalytics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: "",
      charts: [],
      removeChart: [],
      isLoaded: false,
    };
  }

  componentDidMount() {
    let { id } = this.props.match.params;
    let that = this;
    let payload = {
      groupId: id,
      modelName: "Chart",
      noLoader: true,
      // modelType:'action'
    };
    this.props.highlightMenu("A");
    axios.post(url.getSingleGroupItems, payload).then(({ data }) => {
      console.log("charts ---- ", data.data);
      that.setState({
        charts: data.data.items,
        isLoaded: true,
      });
    });
  }

  viewAction = item => {
    this.props.history.push(`/home/planning/${item._id}`);
  };

  removeChart = item => {
    this.setState(prevState => ({
      charts: prevState.charts.filter(e => e._id != item.modelId),
    }));
  };

  chartRemoveBoolean=(item)=>{
    return groupRolePriviledge({
      role: this.props.currentRole,
      action: 0,
      group: this.props.group,    
      role_priv: [0, 1, 2],
      comparison: null,
      isAdmin: this.props.currentRole == 0,
    }) || item.userId == this.props.user.profile._id || (item.linkedByUser &&item.linkedByUser._id == this.props.user.profile._id)
  }

  renderCharts = () => {
    let { charts, isLoaded } = this.state;
    if (isLoaded) {
      if (charts && charts.length > 0) {
        return (
          <div className="row px-1 grp_single_page_render_analytics">
            {charts.map((item, idx) => {
              return (
                <div
                  className={`col-md-6 col-12 grp_single_page_analytics_item_container`}
                  key={item._id + idx}
                >
                  <LinkedChartItem
                    group={this.props.group}
                    isGroups={true}
                    removeChart={this.removeChart}
                    chart={item}
                    chartRemoveBoolean={this.chartRemoveBoolean}
                  
                  />
                </div>
              );
            })}
          </div>
        );
      } else {
        return (
          <span className="grp_single_page_no_analytics cursor-pointer">
            <img src={noLinkedChart} className="grpNoLinkedCharts" /> No Charts
            have been linked to this group.
            <div
              className="grp_page_events_subtitle"
              onClick={() => this.props.history.push(`/home/analytics/all`)}
            >
              Click here to link analytics.{" "}
            </div>
          </span>
        );
      }
    } else {
      return (
        <div className="grp_single_page_details_analytics_container">
          <span className="grp_single_page_no_analytics">
            <img src={loadingItems} className="grpNoLinkedCharts" /> Loading...
          </span>
        </div>
      );
    }
  };

  render() {
    return (
      <span className="grp_single_page_stories_container ">
        <div className="grp_single_page_details_analytics_container">
          {this.renderCharts()}
        </div>
      </span>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: dashboard => dispatch(actionCreators.updateReport(dashboard)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(GroupAnalytics, axios)));
